import React, { Component } from "react";
import { invokeApig } from "../libs/awsLib";
import { Link } from "react-router-dom";
import { Tab} from 'semantic-ui-react'
import DeviceTypeConfigurations from './DeviceTypeConfigurations'
import AlertConfigurations from './AlertConfigurations'
import FirmwareVersions from './FirmwareVersions'
import SmartOrchestrationDefinitions from './SmartOrchestrationDefinitions'
import AnomalyDetectionThresholds from "./AnomalyDetectionThresholds";

export default class Configure extends Component {
constructor (props) {
    super(props)
    this.state = 
    {
      tabIndex:0,
      securitygroups: false
    }

}

async componentDidMount()
{
  const parseurl=this.props.location.pathname.split('/')
  if (parseurl.length>=3)
  {
    if (parseurl[2])
    {
      this.setState({tabIndex: parseInt(parseurl[2])})
    }
    
  }

} start

  render() {
    const panes = [
        this.props.user.configureaccess.indexOf(7)>-1 && { menuItem: {key: 'Device Configurations', content: 'Device Configurations', icon: 'wrench'}, render: () => <Tab.Pane><DeviceTypeConfigurations darkmode={this.props.darkmode}/></Tab.Pane> },
        this.props.user.configureaccess.indexOf(8)>-1 && { menuItem: {key: 'Alert Behaviour', content: 'Alert Behaviour', icon: 'exclamation'}, render: () => <Tab.Pane><AlertConfigurations darkmode={this.props.darkmode}/></Tab.Pane> },
        this.props.user.configureaccess.indexOf(9)>-1 && { menuItem: {key: 'Firmware Versions', content: 'Firmware Versions', icon: 'list'}, render: () => <Tab.Pane><FirmwareVersions darkmode={this.props.darkmode}/></Tab.Pane> },
        this.props.user.configureaccess.indexOf(10)>-1 && { menuItem: {key: 'Orchestration Definitions', content: 'Orchestration Definitions', icon: 'cogs'}, render: () => <Tab.Pane><SmartOrchestrationDefinitions darkmode={this.props.darkmode}/></Tab.Pane> },
        this.props.user.configureaccess.indexOf(11)>-1 && { menuItem: {key: 'ADTs', content: 'ADTs', icon: 'exclamation triangle'}, render: () => <Tab.Pane><AnomalyDetectionThresholds darkmode={this.props.darkmode}/></Tab.Pane> },

      ]
    return (
    <Tab className="fullpage" menu={{tabular: true, attached: 'top' }} activeIndex={this.state.tabIndex} panes={panes} onTabChange={(event,data)=>{this.setState({tabIndex: data.activeIndex}); this.props.history.push('/configure/'+data.activeIndex)}} />
    );  
  }
}
